export const actions: any = [
  // {
  //   title: 'Load Product',
  //   action: 'load-product',
  //   hidden: false,
  //   icon: 'load-icon',
  // },
  {
    title: 'Edit Columns',
    action: 'edit-columns',
    hidden: false,
    icon: 'columns-icon',
  },
];
